import { useCallback, useEffect, useRef } from 'react';
import styles from './Legal.module.css';

export type LegalReaderProps = {
  /** Hukuki metnin TAMAMI. Kisaltilmis/ozetlenmis hali kabul edilmez. */
  text: string;
  /** Metin sonuna kadar okundugunda BIR KEZ cagrilir. */
  onReachEnd: () => void;
  labelledBy?: string;
};

// Son satirda tam pikselde durmak imkansiz; birkaç piksellik pay olmadan
// "sona geldi" hicbir zaman tetiklenmez (tarayici zoom'u ve kesirli yukseklikler).
const END_TOLERANCE_PX = 24;

/**
 * Kaydirilabilir hukuki metin.
 *
 * SONA KADAR OKUMA SARTI arayuzun sussu degil: onay kaydi `legalDocVersion` ile
 * birlikte saklaniyor ve "okudum" iddiasini tasiyor. Kullanicinin metni hic
 * gormeden onaylayabildigi bir ekran, o kaydi degersiz kilar. Mobil taraftaki
 * LegalAgreementScreen ayni kurali uyguluyor; iki istemcinin ayni sozu vermesi
 * gerekiyor.
 */
export function LegalReader({ text, onReachEnd, labelledBy }: LegalReaderProps) {
  const boxRef = useRef<HTMLDivElement | null>(null);
  const reportedRef = useRef(false);

  const report = useCallback(() => {
    if (reportedRef.current) return;
    reportedRef.current = true;
    onReachEnd();
  }, [onReachEnd]);

  const checkReachedEnd = useCallback(() => {
    const box = boxRef.current;
    if (!box) return;
    // Metin kutuya SIGIYORSA kaydirma hic olmaz; sart o durumda kilitlenirdi.
    if (box.scrollHeight - box.clientHeight <= END_TOLERANCE_PX) {
      report();
      return;
    }
    if (box.scrollTop + box.clientHeight >= box.scrollHeight - END_TOLERANCE_PX) {
      report();
    }
  }, [report]);

  // Yeni belge -> sayac sifirlanir. Aksi halde ikinci adim (kullanim kosullari)
  // birinci adimin "okundu" durumunu devralirdi.
  useEffect(() => {
    reportedRef.current = false;
    if (boxRef.current) boxRef.current.scrollTop = 0;
    checkReachedEnd();
  }, [text, checkReachedEnd]);

  return (
    <div
      ref={boxRef}
      className={styles.reader}
      tabIndex={0}
      role="region"
      aria-labelledby={labelledBy}
      onScroll={checkReachedEnd}
    >
      {/* Metin satir sonlarini KORUR: madde numaralari ve paragraf yapisi
          hukuki belgede anlam tasiyor. */}
      <pre className={styles.readerText}>{text}</pre>
    </div>
  );
}
